import { Injectable } from '@angular/core';
import { XpoBoardApiDispatcherBase } from '@xpo-ltl/ngx-ltl-board';
import { XpoAgGridBoardApiAction } from './ag-grid-board-api-actions.model';

@Injectable()
export class XpoAgGridBoardApiDispatcherService extends XpoBoardApiDispatcherBase<XpoAgGridBoardApiAction> {}
